import * as React from 'react';
import { SearchInput, TextInput } from 'react-admin';

const workcalendarFilters = [
    <SearchInput source="search" alwaysOn />,
    <TextInput source="name" />,
];

export default workcalendarFilters;